import { useQuery } from '@tanstack/react-query'
import { useCallback, useMemo } from 'react'
import type { SetoresQuery } from '@/core/types/graphql'
import { SETORES_QUERY } from '../data/setores'
import { request } from '../../../core/utils/request'

export const useSetores = () => {
  const { data: { setores = [] } = {}, isLoading: loading } = useQuery({
    queryKey: ['setores'],
    queryFn: async () => await request<SetoresQuery>(SETORES_QUERY)
  })

  const setoresOptions = useCallback(
    (divisaoId?: string) =>
      setores
        ?.filter(it => (divisaoId ? it?.divisao?.id === divisaoId : false))
        .map(it => ({ value: it?.id, label: it?.nome })),
    [setores]
  )

  const setoresByDivisaoMapOptions = useMemo(() => {
    return setores?.reduce((map, setor) => {
      const divisaoId = setor?.divisao?.id

      if (!map.has(divisaoId)) {
        map.set(divisaoId, [])
      }

      map.get(divisaoId).push({
        label: setor?.nome,
        value: setor?.id
      })

      return map
    }, new Map())
  }, [setores])

  return { setores, setoresOptions, loading, setoresByDivisaoMapOptions }
}
